import './credit-usage-list-modal.scss';
import { ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useModalData } from '../../../store/modal/modalHooks';
import CreditUsageListTableContainer from '../../pages/credits-management/CreditUsageListTableContainer';

const CreditUsageListModal = () => {
  const { t } = useTranslation();
  const modalData = useModalData();

  return (
    <div className="usage-list-modal">
      <ModalHeader>
        <p className="modal-header-title">
          {t('CREDIT_USAGE_LIST_MODAL_TITLE')}
        </p>
      </ModalHeader>
      <CreditUsageListTableContainer
        id={modalData?.data?.id}
        isPersonal={modalData?.data.isPersonal}
      />
    </div>
  );
};

export default CreditUsageListModal;
